// Link clickeable a un documento referenciado (OC / Factura / Nota de Crédito).
// Al hacer click abre el documento en un modal global (ver DocRefContext), sin
// cambiar de menú. Si no hay identificador válido, renderiza texto plano.
import { useDocRef } from '../contexts/DocRefContext';
import { Package, FileText } from 'lucide-react';

export function DocRefLink({
  tipo,           // 'oc' | 'dte'
  numero,         // requerido si tipo='oc'
  folio,          // requerido si tipo='dte'
  rut,            // opcional: RUT emisor para desambiguar el DTE
  label,          // texto a mostrar (por defecto numero/folio)
  children,
  icon = true,
  className = '',
  testId,
}) {
  const { openDoc } = useDocRef();
  const id = tipo === 'oc' ? numero : folio;
  const text = children ?? label ?? id;

  if (id === undefined || id === null || id === '' || id === '—' || id === '-') {
    return <span className="text-gray-400">{text ?? '—'}</span>;
  }

  const Icon = tipo === 'oc' ? Package : FileText;

  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); openDoc({ tipo, numero, folio, rut }); }}
      className={`inline-flex items-center gap-0.5 text-blue-600 hover:text-blue-800 hover:underline font-medium cursor-pointer transition-colors ${className}`}
      title={tipo === 'oc' ? `Ver OC ${id}` : `Ver documento folio ${id}`}
      data-testid={testId || `docref-${tipo}-${id}`}
    >
      {icon && <Icon className="h-3 w-3 flex-shrink-0" />}
      {text}
    </button>
  );
}
